/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsReverseAliases {
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  MAIN_CONTENT_PANEL = 'main-content-panel',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  REASON_AUTOCOMPLETE = 'reason-autocomplete',
  REASON_FETCH = 'reason-fetch',
  REASON_FIELD = 'reason-field',
  REASON_MAPPER = 'reason-mapper',
  REASON_TEXT = 'reason-text',
  RESERVED_BLOOD_PRODUCTS_REVERSE_LAYOUT = 'reserved-blood-products-reverse-layout',
  REVERSE_FORM = 'reverse-form',
  SCHEDULE_DATE_FIELD = 'schedule-date-field',
  SCHEDULE_DATE_INPUT = 'schedule-date-input',
  TITLE_FIELD = 'title-field',
  TITLE_PANEL = 'title-panel',
  TITLE_TEXT = 'title-text',
}
export { ReservedBloodProductsReverseAliases };
